(() => {
  if (window.sctFindMySizeReady) return;
  window.sctFindMySizeReady = true;

  const ICON_BASE = "https://cdn.shopify.com/s/files/1/0798/0086/0903/files/";
  function icon(name, w, h) {
    return "--eqfs-src:url(" + ICON_BASE + name + ".svg);--eqfs-w:" + w + "px;--eqfs-h:" + h + "px";
  }

  const GARMENTS = {
    sweatshirt: {
      name: "Sweatshirt",
      sizes: [
        { label: "S", chest: 36 },
        { label: "M", chest: 40 },
        { label: "L", chest: 44 },
        { label: "XL", chest: 48 },
        { label: "2XL", chest: 52 },
        { label: "3XL", chest: 56 },
        { label: "4XL", chest: 60 },
        { label: "5XL", chest: 64 }
      ]
    },
    tshirt: {
      name: "Unisex T-Shirt",
      sizes: [
        { label: "S", chest: 36 },
        { label: "M", chest: 40 },
        { label: "L", chest: 44 },
        { label: "XL", chest: 48 },
        { label: "2XL", chest: 52 },
        { label: "3XL", chest: 56 },
        { label: "4XL", chest: 60 },
        { label: "5XL", chest: 64 }
      ]
    },
    longsleeve: {
      name: "Long Sleeve",
      sizes: [
        { label: "S", chest: 36 },
        { label: "M", chest: 40 },
        { label: "L", chest: 44 },
        { label: "XL", chest: 48 },
        { label: "2XL", chest: 52 },
        { label: "3XL", chest: 56 },
        { label: "4XL", chest: 60 },
        { label: "5XL", chest: 64 }
      ]
    },
    hoodie: {
      name: "Hoodie",
      sizes: [
        { label: "S", chest: 36 },
        { label: "M", chest: 40 },
        { label: "L", chest: 44 },
        { label: "XL", chest: 48 },
        { label: "2XL", chest: 52 },
        { label: "3XL", chest: 56 },
        { label: "4XL", chest: 60 },
        { label: "5XL", chest: 64 }
      ]
    },
    vneck: {
      name: "Ladies V-Neck",
      sizes: [
        { label: "S", chest: 37 },
        { label: "M", chest: 40 },
        { label: "L", chest: 44 },
        { label: "XL", chest: 48 },
        { label: "2XL", chest: 52 },
        { label: "3XL", chest: 56 }
      ]
    }
  };

  const CHEST_MEN = [
    [64, 120, 34, 35, 37, 38], [64, 140, 35, 37, 38, 40], [64, 160, 37, 39, 40, 42], [64, 180, 39, 41, 42, 44],
    [66, 130, 34, 36, 37, 39], [66, 150, 36, 38, 39, 41], [66, 170, 38, 40, 41, 43], [66, 190, 40, 42, 43, 45], [66, 210, 42, 44, 45, 47],
    [68, 140, 35, 37, 38, 40], [68, 160, 37, 38, 40, 42], [68, 180, 39, 41, 42, 44], [68, 200, 41, 43, 44, 46], [68, 220, 43, 45, 46, 48],
    [69, 150, 36, 37, 39, 41], [69, 170, 37, 39, 41, 43], [69, 190, 40, 42, 43, 45], [69, 210, 42, 43, 44, 46],
    [70, 150, 36, 38, 39, 41], [70, 170, 38, 40, 41, 43], [70, 190, 40, 42, 43, 45], [70, 210, 42, 44, 45, 47], [70, 230, 44, 46, 47, 49],
    [72, 160, 37, 39, 40, 42], [72, 180, 39, 41, 43, 45], [72, 200, 41, 43, 45, 47], [72, 220, 43, 45, 46, 48], [72, 240, 45, 47, 48, 50],
    [74, 170, 38, 40, 41, 43], [74, 190, 40, 42, 43, 45], [74, 210, 42, 44, 45, 47], [74, 230, 44, 46, 47, 49],
    [76, 180, 39, 41, 42, 44], [76, 200, 41, 43, 44, 46], [76, 220, 43, 45, 46, 48], [76, 250, 46, 48, 49, 51]
  ];

  const CHEST_WOMEN = [
    [60, 100, 32, 34, 35, 36], [60, 120, 34, 36, 37, 38], [60, 140, 36, 38, 39, 40], [60, 160, 38, 40, 41, 42],
    [62, 110, 33, 35, 36, 37], [62, 130, 35, 37, 38, 39], [62, 150, 37, 39, 40, 41], [62, 170, 39, 41, 42, 43],
    [64, 120, 34, 36, 37, 38], [64, 140, 36, 38, 39, 40], [64, 160, 38, 40, 41, 42], [64, 180, 40, 42, 43, 44],
    [66, 130, 35, 37, 38, 39], [66, 150, 37, 39, 40, 41], [66, 170, 39, 41, 42, 43], [66, 190, 41, 43, 44, 45],
    [68, 140, 36, 38, 39, 40], [68, 160, 38, 40, 41, 42], [68, 180, 40, 42, 43, 44], [68, 200, 42, 44, 45, 46],
    [70, 150, 37, 39, 40, 41], [70, 170, 39, 41, 42, 43], [70, 190, 41, 43, 44, 45]
  ];

  const BUILD_COLUMN = { slim: 2, regular: 3, athletic: 4, broad: 5, full: 5 };
  const FIT_EASE = { fitted: -2, regular: 0.5, relaxed: 4.5 };

  const HEIGHTS = [
    [60, `5'0" (152 cm)`], [61, `5'1" (155 cm)`], [62, `5'2" (157 cm)`], [63, `5'3" (160 cm)`],
    [64, `5'4" (163 cm)`], [65, `5'5" (165 cm)`], [66, `5'6" (168 cm)`], [67, `5'7" (170 cm)`],
    [68, `5'8" (173 cm)`], [69, `5'9" (175 cm)`], [70, `5'10" (178 cm)`], [71, `5'11" (180 cm)`],
    [72, `6'0" (183 cm)`], [73, `6'1" (185 cm)`], [74, `6'2" (188 cm)`], [75, `6'3" (191 cm)`],
    [76, `6'4" (193 cm)`], [77, `6'5" (196 cm)`], [78, `6'6"+ (198 cm)`]
  ];

  const WEIGHTS = [
    [115, "100-130 lbs (45-59 kg)"], [142, "130-155 lbs (59-70 kg)"], [167, "155-180 lbs (70-82 kg)"],
    [192, "180-205 lbs (82-93 kg)"], [217, "205-230 lbs (93-104 kg)"], [245, "230-260 lbs (104-118 kg)"],
    [275, "260-290 lbs (118-132 kg)"], [305, "290-320 lbs (132-145 kg)"], [335, "320-350 lbs (145-159 kg)"],
    [365, "350+ lbs (159+ kg)"]
  ];

  function lookupChest(heightIn, weightLbs, build, gender) {
    const table = gender === "women" ? CHEST_WOMEN : CHEST_MEN;
    const column = BUILD_COLUMN[build];
    const heights = [];
    table.forEach(row => {
      if (heights.indexOf(row[0]) < 0) heights.push(row[0]);
    });
    heights.sort((a, b) => a - b);
    let low = heights[0];
    let high = heights[heights.length - 1];
    for (let i = 0; i < heights.length - 1; i += 1) {
      if (heightIn >= heights[i] && heightIn <= heights[i + 1]) {
        low = heights[i];
        high = heights[i + 1];
        break;
      }
    }
    if (heightIn <= heights[0]) { low = heights[0]; high = low; }
    if (heightIn >= heights[heights.length - 1]) { low = heights[heights.length - 1]; high = low; }

    function byWeight(h) {
      const rows = table.filter(row => row[0] === h).sort((a, b) => a[1] - b[1]);
      if (!rows.length) return null;
      if (weightLbs <= rows[0][1]) return rows[0][column];
      const last = rows[rows.length - 1];
      if (weightLbs >= last[1]) return last[column];
      for (let i = 0; i < rows.length - 1; i += 1) {
        if (weightLbs >= rows[i][1] && weightLbs <= rows[i + 1][1]) {
          const t = (weightLbs - rows[i][1]) / (rows[i + 1][1] - rows[i][1]);
          return rows[i][column] + t * (rows[i + 1][column] - rows[i][column]);
        }
      }
      return rows[0][column];
    }

    const chestLow = byWeight(low);
    const chestHigh = byWeight(high);
    if (chestLow === null) return chestHigh;
    if (chestHigh === null || low === high) return chestLow;
    return chestLow + ((heightIn - low) / (high - low)) * (chestHigh - chestLow);
  }

  function normalizeText(value) {
    return String(value || "").toLowerCase().replace(/['’]/g, "").replace(/[^a-z0-9]+/g, " ").trim();
  }

  function mapStyle(value) {
    const text = normalizeText(value);
    if (text.includes("hoodie") || text.includes("hooded")) return "hoodie";
    if (text.includes("long sleeve") || text.includes("longsleeve")) return "longsleeve";
    if (text.includes("sweatshirt") || text.includes("sweat shirt") || text.includes("crewneck") || text.includes("crew neck")) return "sweatshirt";
    if (text.includes("v neck") || text.includes("vneck") || text.includes("lady v") || text.includes("women v") || text.includes("womens v")) return "vneck";
    if (text.includes("t shirt") || text.includes("tshirt") || text.includes("unisex tee") || text.includes("classic tee") || text === "tee") return "tshirt";
    return null;
  }

  function optionCard(group, value, iconStyle, title, subtitle) {
    return '<button type="button" class="eqfs-card" data-eqfs-group="' + group + '" data-eqfs-value="' + value + '">' +
      '<span class="eqfs-card__icon" style="' + iconStyle + '"></span>' +
      '<span class="eqfs-card__title">' + title + '</span>' +
      '<span class="eqfs-card__sub">' + subtitle + '</span>' +
      '</button>';
  }

  function selectMarkup(target, placeholder, rows) {
    let html = '<div class="eqfs-select"><select data-eqfs-input="' + target + '"><option value="">' + placeholder + '</option>';
    rows.forEach(row => {
      html += '<option value="' + row[0] + '">' + row[1] + '</option>';
    });
    return html + '</select></div>';
  }

  function wizardMarkup() {
    return '<div class="eqfs-dots"><span></span><span></span><span></span><span></span><span></span></div>' +
      '<div class="eqfs-step" data-eqfs-step="0">' +
        '<p class="eqfs-step-label">Step 1 of 5</p>' +
        '<h3 class="eqfs-question">Shopping for</h3>' +
        '<div class="eqfs-cards eqfs-cards--2">' +
          optionCard("gender", "men", icon("eqfs-gender-men", 28, 56), "Men\u2019s Fit", "Standard unisex sizing") +
          optionCard("gender", "women", icon("eqfs-gender-women", 28, 56), "Women\u2019s Fit", "Adjusted for women\u2019s builds") +
        '</div>' +
      '</div>' +
      '<div class="eqfs-step" data-eqfs-step="1" hidden>' +
        '<p class="eqfs-step-label">Step 2 of 5</p>' +
        '<h3 class="eqfs-question">How tall are you?</h3>' +
        selectMarkup("height", "Select your height", HEIGHTS) +
      '</div>' +
      '<div class="eqfs-step" data-eqfs-step="2" hidden>' +
        '<p class="eqfs-step-label">Step 3 of 5</p>' +
        '<h3 class="eqfs-question">What\u2019s your weight range?</h3>' +
        '<p class="eqfs-hint">We don\u2019t store this information.</p>' +
        selectMarkup("weight", "Select your weight range", WEIGHTS) +
      '</div>' +
      '<div class="eqfs-step" data-eqfs-step="3" hidden>' +
        '<p class="eqfs-step-label">Step 4 of 5</p>' +
        '<h3 class="eqfs-question">What best describes your build?</h3>' +
        '<div class="eqfs-cards eqfs-cards--4" data-eqfs-build="men">' +
          optionCard("build", "slim", icon("eqfs-build-men-slim", 25, 72), "Lean", "Narrow") +
          optionCard("build", "regular", icon("eqfs-build-men-regular", 29, 72), "Regular", "Average") +
          optionCard("build", "athletic", icon("eqfs-build-men-athletic", 31, 72), "Athletic", "Broad") +
          optionCard("build", "broad", icon("eqfs-build-men-broad", 34, 72), "Broad", "Wide frame") +
        '</div>' +
        '<div class="eqfs-cards eqfs-cards--4" data-eqfs-build="women" hidden>' +
          optionCard("build", "slim", icon("eqfs-build-women-slim", 24, 72), "Slim", "Narrow") +
          optionCard("build", "regular", icon("eqfs-build-women-regular", 26, 72), "Regular", "Average") +
          optionCard("build", "athletic", icon("eqfs-build-women-athletic", 26, 72), "Athletic", "Toned") +
          optionCard("build", "full", icon("eqfs-build-women-full", 30, 72), "Curvy", "Fuller figure") +
        '</div>' +
      '</div>' +
      '<div class="eqfs-step" data-eqfs-step="4" hidden>' +
        '<p class="eqfs-step-label">Step 5 of 5</p>' +
        '<h3 class="eqfs-question">How do you like your shirts to fit?</h3>' +
        '<div class="eqfs-cards eqfs-cards--3">' +
          optionCard("fit", "fitted", icon("eqfs-fit-fitted", 46, 96), "Fitted", "Close to the body") +
          optionCard("fit", "regular", icon("eqfs-fit-regular", 48, 96), "Regular", "Classic comfortable") +
          optionCard("fit", "relaxed", icon("eqfs-fit-relaxed", 52, 96), "Relaxed", "Loose &amp; roomy") +
        '</div>' +
      '</div>' +
      '<div class="eqfs-step" data-eqfs-step="result" hidden>' +
        '<div class="eqfs-result">' +
          '<p class="eqfs-result__eyebrow">We recommend</p>' +
          '<div class="eqfs-result__circle" data-eqfs-circle></div>' +
          '<p class="eqfs-result__conf" data-eqfs-confidence></p>' +
          '<p class="eqfs-result__detail" data-eqfs-detail></p>' +
        '</div>' +
        '<p class="eqfs-note">Between sizes? We recommend sizing up.</p>' +
        '<button type="button" class="eqfs-apply" data-eqfs-apply>Select This Size &amp; Close</button>' +
        '<button type="button" class="eqfs-restart" data-eqfs-restart>Start over</button>' +
      '</div>' +
      '<div class="eqfs-nav" data-eqfs-nav>' +
        '<button type="button" class="eqfs-back" data-eqfs-back hidden>Back</button>' +
        '<button type="button" class="eqfs-next" data-eqfs-next disabled>Continue</button>' +
      '</div>';
  }

  const RULER_ICON = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/></svg>';

  function variantSelects(overlay) {
    return document.querySelector("variant-picker") || document.querySelector("variant-selects") || document.querySelector("variant-radios");
  }

  function availableProductSizes(overlay) {
    const container = variantSelects(overlay);
    if (!container) return null;
    const set = {};
    container.querySelectorAll('input[type="radio"], select option').forEach(el => {
      const optName = (el.getAttribute("data-option-name") || el.name || (el.parentElement && el.parentElement.name) || "").toLowerCase();
      if (optName.includes("size")) {
        set[String(el.value).trim()] = true;
      }
    });
    return Object.keys(set).length ? set : null;
  }

  function buildWizard(overlay) {
    if (overlay.dataset.eqfsReady === "true") return;
    const scroll = overlay.querySelector(".eq-size-modal__scroll");
    const header = scroll && scroll.querySelector(".eq-size-header");
    if (!scroll || !header) return;
    overlay.dataset.eqfsReady = "true";

    const tabs = document.createElement("div");
    tabs.className = "eqfs-tabs";
    tabs.setAttribute("role", "tablist");
    tabs.innerHTML =
      '<button type="button" class="eqfs-tab is-active" data-eqfs-tab="chart" aria-selected="true">Size Chart</button>' +
      '<button type="button" class="eqfs-tab" data-eqfs-tab="calc" aria-selected="false">' + RULER_ICON + ' Find My Size</button>';

    const chartPanel = document.createElement("div");
    chartPanel.className = "eqfs-panel";
    chartPanel.setAttribute("data-eqfs-panel", "chart");
    while (header.nextSibling) {
      chartPanel.appendChild(header.nextSibling);
    }

    const calcPanel = document.createElement("div");
    calcPanel.className = "eqfs-panel";
    calcPanel.setAttribute("data-eqfs-panel", "calc");
    calcPanel.hidden = true;
    calcPanel.innerHTML = wizardMarkup();

    scroll.appendChild(tabs);
    scroll.appendChild(chartPanel);
    scroll.appendChild(calcPanel);

    wireWizard(overlay, tabs, calcPanel);
  }

  function wireWizard(overlay, tabs, panel) {
    const state = { step: 0, gender: null, height: null, weight: null, build: null, fit: null, result: null };
    const dots = panel.querySelectorAll(".eqfs-dots span");
    const steps = panel.querySelectorAll("[data-eqfs-step]");
    const nav = panel.querySelector("[data-eqfs-nav]");
    const backButton = panel.querySelector("[data-eqfs-back]");
    const nextButton = panel.querySelector("[data-eqfs-next]");
    const heightSelect = panel.querySelector('[data-eqfs-input="height"]');
    const weightSelect = panel.querySelector('[data-eqfs-input="weight"]');

    function showPanel(name) {
      overlay.querySelectorAll("[data-eqfs-panel]").forEach(item => {
        item.hidden = item.getAttribute("data-eqfs-panel") !== name;
      });
      tabs.querySelectorAll("[data-eqfs-tab]").forEach(button => {
        const active = button.getAttribute("data-eqfs-tab") === name;
        button.classList.toggle("is-active", active);
        button.setAttribute("aria-selected", active ? "true" : "false");
      });
      overlay.dataset.eqfsPanel = name;
    }

    function showStep(step) {
      state.step = step;
      steps.forEach(item => {
        item.hidden = item.getAttribute("data-eqfs-step") !== String(step);
      });
      const isResult = step === "result";
      nav.hidden = isResult;
      if (!isResult) {
        backButton.hidden = step === 0;
        nextButton.textContent = step === 4 ? "See My Size" : "Continue";
        validate();
      }
      if (step === 3) {
        panel.querySelectorAll("[data-eqfs-build]").forEach(group => {
          group.hidden = group.getAttribute("data-eqfs-build") !== state.gender;
        });
      }
      dots.forEach((dot, index) => {
        dot.classList.toggle("is-done", isResult || index < step);
        dot.classList.toggle("is-current", !isResult && index === step);
      });
    }

    function validate() {
      let ok = false;
      if (state.step === 0) ok = !!state.gender;
      else if (state.step === 1) ok = !!state.height;
      else if (state.step === 2) ok = !!state.weight;
      else if (state.step === 3) ok = !!state.build;
      else if (state.step === 4) ok = !!state.fit;
      nextButton.disabled = !ok;
    }

    function reset() {
      state.gender = null;
      state.height = null;
      state.weight = null;
      state.build = null;
      state.fit = null;
      state.result = null;
      panel.querySelectorAll(".eqfs-card").forEach(card => card.classList.remove("is-selected"));
      heightSelect.value = "";
      weightSelect.value = "";
      showStep(0);
    }

    function activeStyleKey() {
      const tab = overlay.querySelector(".eq-style-tab.is-active");
      const key = tab && tab.getAttribute("data-eq-style");
      return GARMENTS[key] ? key : "tshirt";
    }

    function calculate() {
      const styleKey = activeStyleKey();
      const garment = GARMENTS[styleKey];
      const availSet = availableProductSizes(overlay);
      const candidateSizes = availSet
        ? garment.sizes.filter(s => availSet[s.label])
        : garment.sizes;
      const pool = candidateSizes.length ? candidateSizes : garment.sizes;

      const bodyChest = lookupChest(parseFloat(state.height), parseFloat(state.weight), state.build, state.gender);
      const target = bodyChest + FIT_EASE[state.fit];
      let best = pool[0];
      let bestDistance = Infinity;
      pool.forEach(size => {
        const diff = size.chest - target;
        const distance = diff < 0 ? Math.abs(diff) * 2 : Math.abs(diff);
        if (distance < bestDistance) {
          bestDistance = distance;
          best = size;
        }
      });

      const gap = Math.abs(best.chest - target);
      const confidence = gap < 1.5 ? 95 : gap < 3 ? 91 : gap < 5 ? 87 : 82;
      const room = best.chest - bodyChest;
      const roomText = room >= 0.5
        ? ', leaving about <strong>' + room.toFixed(1) + '" of room</strong> for a comfortable ' + state.fit + ' fit.'
        : ', so it sits close to the body. Size up if you like a little more room.';

      state.result = { size: best.label, styleKey: styleKey };
      panel.querySelector("[data-eqfs-circle]").textContent = best.label;
      panel.querySelector("[data-eqfs-confidence]").textContent = confidence + "% confidence";
      panel.querySelector("[data-eqfs-detail]").innerHTML =
        'Based on your profile (~' + Math.round(bodyChest) + '" chest), a <strong>' + best.label +
        '</strong> in the ' + garment.name + ' measures <strong>' + best.chest + '"</strong> around' + roomText;
      showStep("result");
    }

    panel.addEventListener("click", event => {
      const card = event.target.closest(".eqfs-card");
      if (card) {
        const group = card.getAttribute("data-eqfs-group");
        const value = card.getAttribute("data-eqfs-value");
        card.parentElement.querySelectorAll(".eqfs-card").forEach(item => item.classList.remove("is-selected"));
        card.classList.add("is-selected");
        state[group] = value;
        if (group === "gender") state.build = null;
        validate();
        return;
      }
      if (event.target.closest("[data-eqfs-next]")) {
        if (nextButton.disabled) return;
        if (state.step < 4) showStep(state.step + 1);
        else calculate();
        return;
      }
      if (event.target.closest("[data-eqfs-back]")) {
        if (state.step > 0) showStep(state.step - 1);
        return;
      }
      if (event.target.closest("[data-eqfs-restart]")) {
        reset();
        return;
      }
      if (event.target.closest("[data-eqfs-apply]")) {
        if (state.result) applyRecommendation(overlay, state.result);
        const closeButton = overlay.querySelector("[data-eq-size-close]");
        if (closeButton) closeButton.click();
      }
    });

    panel.addEventListener("change", event => {
      const input = event.target.closest("[data-eqfs-input]");
      if (input) {
        state[input.getAttribute("data-eqfs-input")] = input.value;
        validate();
      }
    });

    tabs.addEventListener("click", event => {
      const button = event.target.closest("[data-eqfs-tab]");
      if (button) showPanel(button.getAttribute("data-eqfs-tab"));
    });

    overlay.querySelectorAll(".eq-style-tab").forEach(button => {
      button.addEventListener("click", () => {
        if (state.step === "result") calculate();
      });
    });

    overlay.eqfsReset = panelName => {
      reset();
      showPanel(panelName === "calc" ? "calc" : "chart");
    };

    showStep(0);
  }

  function pickValue(container, value) {
    const radios = container.querySelectorAll('input[type="radio"]');
    for (let i = 0; i < radios.length; i += 1) {
      const label = radios[i].closest("label");
      if (radios[i].value === value && (!label || !label.hasAttribute("hidden"))) {
        radios[i].click();
        radios[i].dispatchEvent(new Event("change", { bubbles: true }));
        return true;
      }
    }
    const selects = container.querySelectorAll("select");
    for (let i = 0; i < selects.length; i += 1) {
      const options = selects[i].options;
      for (let j = 0; j < options.length; j += 1) {
        if (options[j].value === value && !options[j].disabled) {
          selects[i].value = value;
          selects[i].dispatchEvent(new Event("change", { bubbles: true }));
          return true;
        }
      }
    }
    return false;
  }

  function applyRecommendation(overlay, result) {
    const container = variantSelects(overlay);
    if (!container) return;
    pickValue(container, result.size);
  }

  function addInlineLink() {
    // Deduplicate any morphed overlays inside variant-picker if body already has the initialized overlay
    document.querySelectorAll("variant-picker .eq-size-overlay").forEach(dup => {
      const bodyOverlay = document.querySelector("body > #" + CSS.escape(dup.id));
      if (bodyOverlay && bodyOverlay !== dup) {
        dup.remove();
      }
    });
    document.querySelectorAll(".size-option-heading").forEach(heading => {
      let link = heading.querySelector(".eqfs-inline-link");
      if (!link) {
        link = document.createElement("button");
        link.type = "button";
        link.className = "eqfs-inline-link";
        link.innerHTML = RULER_ICON + " Find My Size";
        heading.appendChild(link);
      }
      const holder = heading.querySelector(".size-chart-inline");
      if (holder) holder.style.setProperty("display", "none", "important");
    });
  }

  function scan() {
    document.querySelectorAll(".eq-size-overlay").forEach(buildWizard);
    addInlineLink();
  }

  document.addEventListener("click", event => {
    const calcBtn = event.target.closest(".eqfs-inline-link");
    const chartBtn = event.target.closest("[data-eq-size-open]");
    if (!calcBtn && !chartBtn) return;
    const wanted = calcBtn ? "calc" : "chart";
    const ctrlId = (calcBtn && calcBtn.getAttribute("aria-controls")) || (chartBtn && chartBtn.getAttribute("aria-controls"));
    const overlay = (ctrlId && document.getElementById(ctrlId)) || document.querySelector(".eq-size-overlay");
    if (!overlay) return;
    buildWizard(overlay);
    if (typeof overlay.sctOpenModal === "function") {
      overlay.sctOpenModal();
    } else {
      overlay.hidden = false;
      overlay.setAttribute("aria-hidden", "false");
      document.body.classList.add("eq-size-popup-open");
    }
    if (overlay.eqfsReset) overlay.eqfsReset(wanted);
  });

  let scanQueued = false;
  function queueScan() {
    if (scanQueued) return;
    scanQueued = true;
    window.setTimeout(() => {
      scanQueued = false;
      scan();
    }, 50);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scan);
  } else {
    scan();
  }
  new MutationObserver(queueScan).observe(document.body, { childList: true, subtree: true });
})();
